// extracted by mini-css-extract-plugin
module.exports = {"container":"_2iN7J","align-right":"_16mah","alignRight":"_16mah"};